import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
Vue.filter('time', function (value) {
  var is24HrFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (value) {
    var date = new Date(Date.parse(value));
    var hours = date.getHours();
    var min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();

    if (!is24HrFormat) {
      var time = hours > 12 ? 'AM' : 'PM';
      hours = hours % 12 || 12;
      return hours + ':' + min + ' ' + time;
    }

    return hours + ':' + min;
  }
});